"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var react_lazyload_1 = tslib_1.__importDefault(require("react-lazyload"));
var template_1 = tslib_1.__importDefault(require("lodash/template"));
var MediaPreloader_1 = tslib_1.__importDefault(require("../_common/MediaPreloader"));
var VideoModule = function (_a) {
    var cdnTemplate = _a.cdnTemplate, moduleData = _a.moduleData;
    var imagePath = moduleData.imagePath, ratio = moduleData.ratio, videoPath = moduleData.videoPath;
    var imageUrl = moduleData.imageUrl, videoUrl = moduleData.videoUrl;
    if (imagePath && cdnTemplate) {
        var compileFromCdnTemplate = template_1.default(cdnTemplate);
        imageUrl = compileFromCdnTemplate({ path: imagePath });
    }
    if (videoPath && cdnTemplate) {
        var compileFromCdnTemplate = template_1.default(cdnTemplate);
        videoUrl = compileFromCdnTemplate({ path: videoPath });
    }
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(react_lazyload_1.default, { once: true, offset: 300 },
            react_1.default.createElement(MediaPreloader_1.default, { ratio: ratio },
                react_1.default.createElement("video", { controls: true, poster: imageUrl },
                    react_1.default.createElement("track", { default: true, kind: "captions" }),
                    react_1.default.createElement("source", { src: videoUrl, type: "video/mp4" }),
                    react_1.default.createElement("img", { src: imageUrl, alt: "videoModule" }))))));
};
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    video {\n        display: block;\n    }\n"], ["\n    video {\n        display: block;\n    }\n"])));
exports.default = react_1.default.memo(VideoModule);
var templateObject_1;
//# sourceMappingURL=VideoModule.js.map